const CACHE_NAME = "mailercloud-cache-v1";
const PRE_CACHED_ASSETS = [
  // process.env.VUE_APP_VUE2_APP_URL +
  //   "/js/app.js?v=" +
  //   process.env.VUE_APP_ASSET_VERSION,
  // process.env.VUE_APP_VUE3_APP_URL +
  //   "/js/app.js?v=" +
  //   process.env.VUE_APP_ASSET_VERSION,
  // "/index.html",
];

self.addEventListener("install", function (event) {
  event.waitUntil(
    caches.open(CACHE_NAME).then(function (cache) {
      let cachePromises = PRE_CACHED_ASSETS.map(function (asset) {
        var url = new URL(asset, location.href);
        var request = new Request(url);
        return fetch(request).then(function (response) {
          return cache.put(asset, response);
        });
      });

      return Promise.all(cachePromises);
    })
  );
});
